import { Theme } from '@mui/material';
import { liftangoBrandTokens } from '../../../../theme/brandTokens';

import { opsColors } from '../../../../theme/opsTokens';

/**
 * Ordered palette for categorical chart series, drawn from the Liftango
 * brand tokens so admin charts harmonize with the rest of Atlas.
 */
export function categoricalSeriesPalette(theme: Theme): string[] {
  return [
    liftangoBrandTokens.palette.primary,        // orange
    opsColors.semantic.info.color,                    // blue
    liftangoBrandTokens.palette.secondary,      // teal
    liftangoBrandTokens.palette.success,        // green
    liftangoBrandTokens.palette.warning,        // amber
    liftangoBrandTokens.palette.tertiary,       // dark
    theme.palette.grey[500],
  ];
}

/** Bucket→color mapping used by Top events bars and the donut chart. */
export function categoryColor(category: string | null | undefined, theme: Theme): string {
  switch ((category ?? '').toLowerCase()) {
    case 'frontend':
      return opsColors.semantic.info.color;
    case 'http_request':
      return liftangoBrandTokens.palette.primary;
    case 'custom':
      return liftangoBrandTokens.palette.secondary;
    default:
      return theme.palette.grey[500];
  }
}
